"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = require("./Button.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**

 * Primary UI component for user interaction

 */
var Button = function Button(_ref) {
  var text = _ref.text,
      _ref$background = _ref.background,
      background = _ref$background === void 0 ? "#3699FF" : _ref$background,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "medium" : _ref$size,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "Button" : _ref$label,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$textTransform = _ref.textTransform,
      textTransform = _ref$textTransform === void 0 ? "lowercase" : _ref$textTransform,
      borderColor = _ref.borderColor,
      _ref$fontWeight = _ref.fontWeight,
      fontWeight = _ref$fontWeight === void 0 ? "300" : _ref$fontWeight,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "contained" : _ref$variant,
      props = _objectWithoutProperties(_ref, ["text", "background", "size", "label", "disabled", "textTransform", "borderColor", "fontWeight", "variant"]);

  return /*#__PURE__*/_react.default.createElement(_Button.StyledButton, _extends({
    type: "button",
    text: text,
    background: background,
    size: size,
    disabled: disabled,
    textTransform: textTransform,
    fontWeight: fontWeight,
    variant: variant,
    borderColor: borderColor
  }, props), label);
};

Button.defaultProps = {
  background: "#3699FF",
  size: "medium",
  onClick: undefined
};
var _default = Button;
exports.default = _default;

//# sourceMappingURL=Button.js.map